<template>
  <div>
                  <div class="second_main">
                      <el-form :label-width="'30%'" :model="myInfoFormModel" :rules="rules" ref="myInfoForm">
                      <!--基本信息-->
                      <h4 class="second_title">基本信息</h4>
                        <el-row :gutter="20">
                          <el-col :span="11">
                            <el-form-item label="客户编码" prop="info1">
                              <el-input type="text" placeholder="请输入客户编码" :disabled="true"
                                 v-model="myInfoFormModel.info1"></el-input>
                             </el-form-item>
                          </el-col>
                           <el-col :span="11">
                            <el-form-item label="客户类型" prop="info2">
                              <el-select v-model="myInfoFormModel.info2" placeholder="请选择客户类型"  disabled class="select_width">
                                 <el-option v-for="item in select6" :key="item.value"
                                   :label="item.label" :value="item.value">
                                 </el-option>
                               </el-select>
                             </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row :gutter="20">
                          <el-col :span="11">
                            <el-form-item label="客户姓名" prop="info3">
                              <el-input type="text" placeholder="请输入真实姓名" :disabled="true"
                                 v-model="myInfoFormModel.info3"></el-input>
                             </el-form-item>
                          </el-col>
                           <el-col :span="11">
                            <el-form-item label="注册手机号" prop="info4">
                              <el-input type="text" placeholder="请输入手机号" :disabled="true"
                                 v-model="myInfoFormModel.info4"></el-input>
                             </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row :gutter="20">
                          <el-col :span="11">
                            <el-form-item label="证件类型" prop="info5">
                              <el-select v-model="myInfoFormModel.info5" placeholder="请选择证件类型"  disabled class="select_width">
                                 <el-option v-for="item in select7" :key="item.value"
                                   :label="item.label" :value="item.value">
                                 </el-option>
                               </el-select>
                            </el-form-item>
                          </el-col>
                           <el-col :span="11">
                            <el-form-item label="证件号码" prop="info6">
                              <el-input type="text" placeholder="请输入证件号码" :disabled="true"
                                 v-model="myInfoFormModel.info6"></el-input>
                             </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row :gutter="20">
                          <el-col :span="11">
                            <el-form-item label="性别" prop="info7">
                               <el-select v-model="myInfoFormModel.info7" placeholder="请选择性别" class="select_width" :disabled="true">
                                 <el-option v-for="item in select0" :key="item.value"
                                   :label="item.label" :value="item.value">
                                 </el-option>
                               </el-select>
                             </el-form-item>
                          </el-col>
                           <el-col :span="11">
                            <el-form-item label="出生日期" prop="info8">
                              <el-input type="text" placeholder="请输入出生日期" :disabled="true"
                                 v-model="myInfoFormModel.info8" ></el-input>
                             </el-form-item>
                          </el-col>
                        </el-row>
                <!--  <el-option v-for="item in initialData.repayTypeList" :key="item.baseProductRepay"
                            :label="item.baseProductRepayName" :value="item.baseProductRepay">
                      </el-option>-->
                         <el-row :gutter="20">
                          <el-col :span="11">
                            <el-form-item label="学历" prop="info9">
                             <el-select v-model="myInfoFormModel.info9" placeholder="请选择学历" class="select_width">
                                <!-- <el-option  :key="'01'" :label="'本科'" :value="'01'"></el-option>
                                 <el-option  :key="'02'" :label="'硕士研究生'" :value="'02'"></el-option>
                                 <el-option  :key="'03'" :label="'博士研究生'" :value="'03'"></el-option>
                                 <el-option  :key="'04'" :label="'专科'" :value="'04'"></el-option>
                                 <el-option  :key="'05'" :label="'专科以下'" :value="'05'"></el-option> -->
                                 <el-option v-for="item in select1" :key="item.value"
                                   :label="item.label" :value="item.value">
                                 </el-option>
                               </el-select>
                             </el-form-item>
                          </el-col>
                           <el-col :span="11">
                            <el-form-item label="毕业院校" prop="info10">
                              <el-input type="text" placeholder="请输入毕业院校" :disabled="isEditable === 1"
                                 v-model="myInfoFormModel.info10"></el-input>
                             </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row :gutter="20">
                          <el-col :span="11">
                            <el-form-item label="所属区域" prop="info11" class="is-required">
                               <el-cascader :options="categoryList" :props="cascaderConfig"
                                @active-item-change="cascaderItemChange" @change="categoryChange0" v-model="info11">
                               </el-cascader>
                             </el-form-item>
                          </el-col>
                           <el-col :span="11">
                            <el-form-item label="户别" prop="info12">
                              <el-select v-model="myInfoFormModel.info12" placeholder="请选择户别" ref="repayType" class="select_width">
                                  <el-option v-for="item in select2" :key="item.value"
                                   :label="item.label" :value="item.value">
                                 </el-option>
                               </el-select>
                             </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row>
                          <el-col :span="22">
                            <el-form-item label="户籍地址" prop="info13" class="label_text is-required">
                              <el-input type="textarea" placeholder="请输入户籍地址" :disabled="isEditable === 1"
                                 :rows="2" v-model="myInfoFormModel.info13"></el-input>
                             </el-form-item>
                          </el-col>
                        </el-row>
                      <!--家庭情况-->
                      <h4 class="second_title">家庭情况</h4>
                        <el-row :gutter="20">
                          <el-col :span="11">
                            <el-form-item label="婚姻状况" prop="info14">
                              <el-select v-model="myInfoFormModel.info14" placeholder="请选择" class="select_width">
                              <!--   <el-option :key="'01'" :label="'未婚'" :value="'01'"></el-option>
                                 <el-option :key="'02'" :label="'已婚'" :value="'02'"></el-option>
                                 <el-option :key="'03'" :label="'离异'" :value="'03'"></el-option>
                                 <el-option :key="'04'" :label="'再婚'" :value="'04'"></el-option>
                                 <el-option :key="'05'" :label="'其他'" :value="'05'"></el-option> -->
                                 <el-option v-for="item in select3" :key="item.value"
                                   :label="item.label" :value="item.value">
                                 </el-option>
                               </el-select>
                             </el-form-item>
                          </el-col>
                           <el-col :span="11">
                            <el-form-item label="家庭成员" prop="info15">
                              <el-input type="text" placeholder="请输入家庭成员人数" :disabled="isEditable === 1"
                                 v-model="myInfoFormModel.info15"><template slot="append">人</template></el-input>
                             </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row :gutter="20">
                          <el-col :span="11">
                            <el-form-item label="是否有子女" prop="info16">
                              <el-select v-model="myInfoFormModel.info16" placeholder="请选择" class="select_width">
                               <!--  <el-option :key="'1'" :label="'是'" :value="'1'"></el-option>
                                 <el-option :key="'0'" :label="'否'" :value="'0'"></el-option> -->
                                 <el-option v-for="item in select4" :key="item.value"
                                   :label="item.label" :value="item.value">
                                 </el-option>
                               </el-select>
                             </el-form-item>
                          </el-col>
                           <el-col :span="11">
                            <el-form-item label="住宅状况" prop="info17">
                              <el-select v-model="myInfoFormModel.info17" placeholder="请选择"  class="select_width">
                            <!--     <el-option :key="'0'" :label="'自住'" :value="'0'"></el-option>
                                 <el-option :key="'1'" :label="'空闲'" :value="'1'"></el-option>
                                 <el-option :key="'2'" :label="'出租'" :value="'2'"></el-option> -->
                                 <el-option v-for="item in select5" :key="item.value"
                                   :label="item.label" :value="item.value">
                                 </el-option>
                               </el-select>
                             </el-form-item>
                          </el-col>
                        </el-row>

                     <!--   <el-row :gutter="20">
                          <el-col :span="11">
                            <el-form-item label="居住城市" prop="info18" class="is-required">
                             <el-cascader :options="categoryList" :props="cascaderConfig"
                                @active-item-change="cascaderItemChange" @change="categoryChange1">
                             </el-cascader>
                            </el-form-item>
                          </el-col>
                        </el-row>  -->

                        <el-row>
                          <el-col :span="22">
                            <el-form-item label="居住住址" prop="info19" class="label_text is-required">
                              <el-input type="textarea" :rows="2" placeholder="请输入居住住址" :disabled="isEditable === 1"
                                 v-model="myInfoFormModel.info19"></el-input>
                             </el-form-item>
                          </el-col>
                        </el-row>

                          <!--单位情况-->
                      <h4 class="second_title">单位情况</h4>
                        <el-row :gutter="20">
                          <el-col :span="11">
                            <el-form-item label="工作单位全称" prop="info20">
                              <el-input type="text" placeholder="请输入工作单位全称" :disabled="isEditable === 1"
                                 v-model="myInfoFormModel.info20"></el-input>
                             </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row>
                          <el-col :span="22">
                            <el-form-item label="单位地址" prop="info21" class="label_text">
                              <el-input type="textarea" :rows="2" placeholder="请输入单位地址" :disabled="isEditable === 1"
                                 v-model="myInfoFormModel.info21"></el-input>
                             </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row :gutter="20">
                          <el-col :span="11">
                            <el-form-item label="任职时间" prop="info22">
                             <!-- <el-input type="text" placeholder="请输入任职时间" :disabled="isEditable === 1"
                                 v-model="myInfoFormModel.info22"></el-input> -->
                              <!--兼容ie数据回填问题https://github.com/ElemeFE/element/issues/8548-->
                              <el-date-picker
                                ref="datepicker"
                                placeholder="请选择日期"
                                v-model="myInfoFormModel.info22"
                                type="date"
                                @change="dateChange"
                                value-format="yyyy-MM-dd">
                              </el-date-picker>
                             </el-form-item>
                          </el-col>
                           <el-col :span="11">
                            <el-form-item label="任职岗位" prop="info23">
                              <el-input type="text" placeholder="任职岗位" :disabled="isEditable === 1"
                                 v-model="myInfoFormModel.info23"></el-input>
                             </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row :gutter="20">
                          <el-col :span="11">
                            <el-form-item label="单位电话" prop="info24">
                              <el-input type="text" placeholder="请输入单位电话" :disabled="isEditable === 1"
                                 v-model="myInfoFormModel.info24"></el-input>
                             </el-form-item>
                          </el-col>
                           <el-col :span="11">
                            <el-form-item label="单位性质" prop="info25">
                              <el-input type="text" placeholder="请输入单位性质" :disabled="isEditable === 1"
                                 v-model="myInfoFormModel.info25"></el-input>
                             </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row :gutter="20">
                          <el-col :span="11">
                            <el-form-item label="人事部联系人" prop="info26">
                              <el-input type="text" placeholder="请输入人事部联系人" :disabled="isEditable === 1"
                                 v-model="myInfoFormModel.info26"></el-input>
                             </el-form-item>
                          </el-col>
                           <el-col :span="11">
                            <el-form-item label="人事部联系电话" prop="info27">
                              <el-input type="text" placeholder="请输入人事部联系电话" :disabled="isEditable === 1"
                                 v-model="myInfoFormModel.info27"></el-input>
                             </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row :gutter="20">
                          <el-col :span="11">
                            <el-form-item label="个人年收入" prop="info28" class="units">
                              <el-input type="number" placeholder="请输入个人年收入" :disabled="isEditable === 1"
                                 v-model="myInfoFormModel.info28"></el-input>元
                             </el-form-item>
                          </el-col>
                           <el-col :span="11">
                            <el-form-item label="企业成立年限" prop="info29" class="units">
                              <el-input type="number" placeholder="请输入企业成立年限" :disabled="isEditable === 1"
                                 v-model="myInfoFormModel.info29"></el-input>年
                             </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row :gutter="20">
                          <el-col :span="11">
                            <el-form-item label="已缴社保年限" prop="info30" class="units">
                              <el-input type="number" placeholder="请输入已缴社保年限" :disabled="isEditable === 1"
                                 v-model="myInfoFormModel.info30"></el-input>年
                             </el-form-item>
                          </el-col>
                        </el-row>

                      </el-form>
                 </div>
            <div class="text-center Infosave">
                <el-button type="primary" :loading="isLoading"
                 class="personal-center-form__submit" style="background:#EB662B;" @click="saveInfo" :disabled="isEditable === 1">
                 保存
               </el-button>
          </div>
  </div>
</template>
<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex';
  import * as types from '../../vuex/types';
  export default {
    data () {
      const assignValidator = (message, trigger = 'blur') => Object.assign({
//        required: true,
        message,
        trigger
      }, {
        validator: (rules, value, callback) => {
          if (_.isNaN(Number(value))) {
            callback(new Error(`${message}`));
          } else {
            callback();
          }
        }
      });
      return {
        isEditable: '0',
        Idcard: '0',
        value: '',
        select0: '', // 性别
        select1: '', // 学历
        select2: '', // 非农历
        select3: '', // 婚姻状况
        select4: '', // 是否有子女
        select5: '', // 住宅状况
        select6: '', // 客户类型
        select7: '', // 证件类型
        info11: [], // 所属区域
        cascaderConfig: {
          label: 'label',
          value: 'value',
          children: 'children'
        },
        categoryList: [], // 接收服务端的一级选项
        isLoading: false,
        myInfoFormModel: {
          info1: '', // 客户编码
          info2: '', // 客户类型
          info3: '', // 客户姓名
          info4: '', // 注册手机号
          info5: '', // 证件类型
          info6: '', // 证件号码
          info7: '', // 性别
          info8: '', // 出生日期
          info9: '', // 学历
          info10: '', // 毕业院校
          info11: [], // 所属区域
          info12: '', // 户别
          info13: '', // 户籍地址
          info14: '', // 婚姻状况
          info15: '', // 家庭成员
          info16: '', // 是否有子女
          info17: '', // 住宅状况
          info18: '', // 居住城市
          info19: '', // 居住地址
          info20: '', // 工作单位全称
          info21: '', // 单位地址
          info22: '', // 任职时间
          info23: '', // 任职岗位
          info24: '', // 单位电话
          info25: '', // 单位性质
          info26: '', // 人事部联系人
          info27: '', // 人事部联系电话
          info28: '', // 个人年收入
          info29: '', // 企业成立年限
          info30: '' // 已缴社保年限
        },
        rules: {
          //  info1: [assignValidator('请输入数字', 'blur')],
          info11: [{   // 所属区域
             trigger: 'change',
             required: true,
             validator: (rules, value, callback) => {
               if (value.length === 0) {
                 callback(new Error('请选择所属区域'));
               } else {
                 callback();
               }
             }
           }],
          info13: [{   // 户籍地址
             required: true,
             trigger: 'blur',
             validator: (rules, value, callback) => {
               if (_.trim(value) === '') {
                 callback(new Error('户籍地址不能为空'));
               } else {
                 callback();
               }
             }
           }],
          //  info18: [{   // 居住城市
          //    require: true,
          //    trigger: 'chance',
          //    validator: (rules, value, callback) => {
          //      if (value.length === 0) {
          //         callback(new Error('居住城市不能为空'))
          //      } else {
          //        callback()
          //     }
          //   }
          // }],
          info19: [{    // 居住住址
            require: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
               if (_.trim(value) === '') {
                 callback(new Error('居住住址不能为空'));
               } else {
                 callback();
               }
             }
          }]
        }
      };
    },
    computed: {
      ...mapGetters({
        userInfo: types.GET_USER
      })
    },
    methods: {
      ...mapActions({
        setSuccessMessage: types.SET_SUCCESS_MESSAGE,
        savePersonalInfoall: types.SAVE_PERSONAL_INFO_All,
        getPersonalInitData: types.GET_PERSONAL_INIT_DATA,
        getByCatKey: types.GET_BYCAT_KEY,
        getallSelect: types.GET_ALL_SELECT
      }),
      cascaderItemChange (val) {
        this.getByCatKey({
          catKey: 'area',
          parentId: val[0]
        }).then((res) => {
          this.categoryList.map((item, index) => {
            if (item.value == val[0]) {
              this.categoryList[index].children = res.data;
            }
          });
        });
      },
      categoryChange0 (e) {
        this.myInfoFormModel.info11 = e[1];
      },
      // categoryChange1 (e) {
      //   this.myInfoFormModel.info18 = e[1]
      // },
      dateChange (e) {
        // 格式化value,饿了么格式化似乎无效
        const date = e.replace(/(\s*)/g, '').replace(/年/, '-').replace(/月/, '-').replace(/日/, '');
        this.myInfoFormModel.info22 = date;
      },
      saveInfo () {
        this.$refs.myInfoForm.validate((valid) => {
          if (valid) {
            this.isLoading = true;
            this.savePersonInfo();
          }
        });
      },
      savePersonInfo () {
         // 保存数据
       this.savePersonalInfoall({
           token: this.userInfo.token,
          // personSex: this.myInfoFormModel.info7,
          // personBirthDate: this.myInfoFormModel.info8,
           personEducation: this.myInfoFormModel.info9,
           personCollege: this.myInfoFormModel.info10,
           customerArea: this.myInfoFormModel.info11, // 只传最后一层城市数据
           personCategory: this.myInfoFormModel.info12,
           personCensusAddr: this.myInfoFormModel.info13,
           personMarital: this.myInfoFormModel.info14,
           personFamily: this.myInfoFormModel.info15,
           personExistChild: this.myInfoFormModel.info16,
           personHouse: this.myInfoFormModel.info17,
           b: this.myInfoFormModel.info18,
           personDwellAddr: this.myInfoFormModel.info19,
           personCompanyName: this.myInfoFormModel.info20, // 工作单位全称
           personCompanyAddr: this.myInfoFormModel.info21,
           personCompanyTime: this.myInfoFormModel.info22,
           personCompanyPost: this.myInfoFormModel.info23,
           personCompanyPhone: this.myInfoFormModel.info24,
           personCompanyNature: this.myInfoFormModel.info25,
           personCompanyLinkman: this.myInfoFormModel.info26,
           personCompanyLinkmanPhone: this.myInfoFormModel.info27,
           personYearIncome: this.myInfoFormModel.info28,
           personCompanyAge: this.myInfoFormModel.info29,
           personSocialSecurityTime: this.myInfoFormModel.info30
         }).then((res) => {
          this.isLoading = false;
          if (Number(res.data.code) === 0) {
            this.setSuccessMessage({
              show: true,
              content: '个人信息保存成功'
            });
          } else {
            this.loading = false;
          }
        });
     }
    },
    mounted () {
     // 获得其他select数据
     this.getallSelect().then((res) => {
       this.select0 = res.data[0];
       this.select1 = res.data[1];
       this.select2 = res.data[2];
       this.select3 = res.data[3];
       this.select4 = res.data[4];
       this.select5 = res.data[5];
       this.select6 = res.data[6];
       this.select7 = res.data[7];
     });
    // 先获得省/市区的数据,再动态联动 categoryList为存放的省市数据/info11为初始化数组/myInfoFormModel.info11为传递后台的数据
     this.getByCatKey({
       catKey: 'area',
       parentId: 10000000600002
     }).then((res) => {
      res.data.map((item) => {
        item.children = [];
      });
      this.categoryList = res.data;
    });

    // 获得个人信息数据
     this.getPersonalInitData({
       token: this.userInfo.token,
       customerId: this.userInfo.crmCustomerId
     }).then((res) => {
     if (Number(res.data.rspcode) === 1) {
          const data = res.data.data;
  
          this.myInfoFormModel = {
           info1: data.crmCustomer.customerCode || '', // 客户编码
           info2: data.crmCustomer.customerType || '', // 客户类型 1个人 2企业
           info3: data.crmCustomer.customerName || '', // 客户姓名
           info4: data.crmCustomer.customerLoginName || '', // 注册手机号
           info5: data.crmCustomerPerson.personDocumentType || '', // 证件类型
           info6: data.crmCustomerPerson.personIdentityCard || '', // 证件号码
           info7: data.crmCustomerPerson.personSex || '', // 性别
           info8: data.crmCustomerPerson.personBirthDate || '', // 出生日期
           info9: data.crmCustomerPerson.personEducation || '', // 学历
           info10: data.crmCustomerPerson.personCollege || '', // 毕业院校
           info11: data.location ? data.location[1] : [], // 所属区域
           info12: data.crmCustomerPerson.personCategory || '', // 户别
           info13: data.crmCustomerPerson.personCensusAddr || '', // 户籍地址
           info14: data.crmCustomerPerson.personMarital || '', // 婚姻状况
           info15: data.crmCustomerPerson.personFamily || '', // 家庭成员
           info16: data.crmCustomerPerson.personExistChild || '', // 是否有子女
           info17: data.crmCustomerPerson.personHouse || '', // 住宅状况
           info18: '0', // 居住城市
           info19: data.crmCustomerPerson.personDwellAddr || '', // 居住地址
           info20: data.crmCustomerPerson.personCompanyName || '', // 工作单位全称
           info21: data.crmCustomerPerson.personCompanyAddr || '', // 单位地址
           info22: data.crmCustomerPerson.personCompanyTime || '', // 任职时间
           info23: data.crmCustomerPerson.personCompanyPost || '', // 任职岗位
           info24: data.crmCustomerPerson.personCompanyPhone || '', // 单位电话
           info25: data.crmCustomerPerson.personCompanyNature || '', // 单位性质
           info26: data.crmCustomerPerson.personCompanyLinkman || '', // 人事部联系人
           info27: data.crmCustomerPerson.personCompanyLinkmanPhone || '', // 人事部联系电话
           info28: data.crmCustomerPerson.personYearIncome || '', // 个人年收入
           info29: data.crmCustomerPerson.personCompanyAge || '', // 企业成立年限
           info30: data.crmCustomerPerson.personSocialSecurityTime || ''  // 已缴社保年限
         };
          if (this.$refs.datepicker.$children) {
	          this.$refs.datepicker.$children[0].currentValue = this.myInfoFormModel.info22;
          }

          // 初始化城市值,如果没有location,不需要求初始化
          if (data.location) {
           this.cascaderItemChange(data.location);
           this.info11 = data.location;
         }
//         this.info11 = data.location ? data.location : []
        }
     }).catch((err) => {
       console.log('err', err);
     });
 }
};
</script>
<style lang="scss">
   .second_main{
    margin-top:10px;
  }
   .second_main {
     .el-form-item.units{
       .el-input{
         width: 90% !important;
       }
     }
     .el-form-item{
      float: center;
      }  
   }
  .second_title{
    padding:3px 0px 15px 0px;
  }
  .second_main .el-form-item__label{
      text-align:center;
  }
  .second_main input{
      margin-left:0;
  }
  .second_main .label_text .el-form-item__label{width:14% !important;}
  .second_main .label_text .el-form-item__content{margin-left:15% !important;}
  .select_width .el-input__icon+.el-input__inner{padding-right:95px;}
  .Infosave{margin:15px 0px;}
  .second_main .el-cascader{width:100%;}
  .el-date-editor.el-input {
    width: 260px;
  }
</style>



// WEBPACK FOOTER //
// PersonInfo.vue?8784adca